export default "__VITE_ASSET__BXctSlE1__"